"use client";
import { motion, Variants } from "framer-motion";
import Image from "next/image";

import SectionTitle from "@/shared/app/ui/text/PageSectionTitle";
const container: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.15, ease: "easeOut", duration: 0.5 },
  },
};

const item: Variants = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] },
  },
};

const icons = [
  {
    id: 1,
    title: "전자지갑",
    icon: "/assets/images/page/service/solution/listIcon1.svg",
  },
  {
    id: 2,
    title: "돌봄매칭",
    icon: "/assets/images/page/service/solution/listIcon2.svg",
  },
  {
    id: 3,
    title: "가맹점 포스기",
    icon: "/assets/images/page/service/solution/listIcon3.svg",
  },
  {
    id: 4,
    title: "크라우드 펀딩",
    icon: "/assets/images/page/service/solution/listIcon4.svg",
  },
  {
    id: 5,
    title: "온라인몰",
    icon: "/assets/images/page/service/solution/listIcon5.svg",
  },
  {
    id: 6,
    title: "티켓몰",
    icon: "/assets/images/page/service/solution/listIcon6.svg",
  },
  {
    id: 7,
    title: "기프트몰",
    icon: "/assets/images/page/service/solution/listIcon7.svg",
  },
];

export default function SolutionWalletSection() {
  const wallets = [
    {
      img: "/assets/images/page/service/solution/wallet1.png",
      name: "한밭페이",
      desc: "실물화폐 기반 지역화폐 서비스 한밭페이",
    },
    {
      img: "/assets/images/page/service/solution/wallet2.png",
      name: "서로돌봄",
      desc: "타임뱅크 기반 지역화폐 서로돌봄",
    },
  ];
  return (
    <div className="bg-[#191A1F] rounded-3xl md:rounded-[154px]">
      <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 md:py-30 py-20">
        <SectionTitle
          align="center"
          label="Digital Wallet"
          title={<>지역의 가치를 연결하다</>}
          description={
            <>
              사회적경제와 지역 공동체를 위한
              <br />
              통합 전자지갑 솔루션
            </>
          }
          colorMode="dark"
        />
        {/* 앱 컨테이너 */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="flex justify-between gap-5 md:gap-5 my-20 lg:flex-row flex-col"
        >
          {wallets.map((wallet, index) => (
            <motion.div
              key={index}
              variants={item}
              className="flex flex-1 flex-col"
            >
              {/* 이미지 */}
              <div className="w-full aspect-[4/2] relative overflow-hidden rounded-4xl">
                <Image
                  src={wallet.img}
                  alt={wallet.name}
                  fill
                  className="object-cover transition-transform duration-500 hover:scale-105"
                />
              </div>

              {/* 텍스트 */}
              <div className="mt-3 md:mt-5 px-2">
                <p
                  className="text-base md:text-xl lg:text-2xl leading-6  md:leading-8 text-light-80 tracking-tight "
                  style={{ fontFamily: '"pre-Medium", sans-serif' }}
                >
                  {wallet.name}
                </p>
                <p
                  className="text-lightGray-40 mt-1 leading-relaxed text-sm md:text-base lg:text-lg tracking-tight"
                  style={{ fontFamily: '"pre-Regular", sans-serif' }}
                >
                  {wallet.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
        {/*  */}
        <div className="md:py-40 py-10">
          {/* 타이틀 */}
          <SectionTitle
            align="left"
            label="Core Features"
            title={<>핵심기능</>}
            description={
              <>
                다양한 문제를 해결하고 있는 기업들과
                <br />
                필요한 IT 비용 마련을 위한 컨설팅 및 협업
              </>
            }
            colorMode="dark"
          />
          {/* 기능 리스트 */}
          <section className="w-full mt-20 ">
            <motion.div
              variants={container}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              className="
          grid 
          xl:grid-cols-4 
          lg:grid-cols-3 
          grid-cols-2 
          gap-[14px]
          mx-auto
        "
            >
              {icons.map((itemData) => (
                <motion.div
                  key={itemData.id}
                  variants={item}
                  className="
               flex flex-col items-center justify-center 
               bg-[#26272B] 
               rounded-3xl 
               md:py-7 md:px-5
               py-5 px-3 
               hover:bg-[#1E1F23]  /* hover 시 살짝 더 어두운 색 */
               transition-all duration-300 ease-out
               hover:shadow-[0_0_15px_rgba(0,0,0,0.25)]  /* 은은한 그림자 */
             "
                >
                  {/* 번호 */}
                  <div
                    className="bg-[#191A1F] text-white tracking-tighter text-sm md:text-base px-2 py-1 rounded-lg leading-5 self-baseline "
                    style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
                  >
                    0{itemData.id}
                  </div>
                  <div className="mt-[-18px] md:mt-[-10px] flex flex-col justify-center items-center">
                    {/* 아이콘 */}
                    <div className="relative md:w-14 md:h-14 w-8 h-8 mb-4 flex justify-center items-center">
                      <Image
                        src={itemData.icon}
                        alt={`icon${itemData.id}`}
                        fill
                        className="object-contain"
                      />
                    </div>

                    {/* 타이틀 */}
                    <p
                      className="text-base md:text-xl text-white tracking-tighter leading-5 md:leading-8"
                      style={{ fontFamily: '"pre-Medium", sans-serif' }}
                    >
                      {itemData.title}
                    </p>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </section>
        </div>
      </div>
    </div>
  );
}
